import { Avatar, IconButton } from '@material-ui/core'
import { AttachFile, MoreVert, SearchOutlined } from '@material-ui/icons'
import SendIcon from '@material-ui/icons/Send';
import MenuIcon from '@material-ui/icons/Menu';
import TextField from '@material-ui/core/TextField';
import React, {useState,useEffect,useRef} from 'react'
import './Chat.css'
import { sendTextMessage } from 'network/ApiAxiosMessages';
import {ddns} from '../../../../package.json'

function Chat(props) {
  useEffect(() => {
    scrollToBottom()
  }, [props]);
  const [msg, setMsg] = useState("");
  const [sendMsgBtnState, setSendMsgBtnState] = useState(false);

  const messagesEndRef = useRef(null)

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth"})
  }

  const handleSidebar =()=>{
    props.sidebarToggleSetState(!props.sidebarToggleState)
  }

  const handleSendMsg =async()=>{
    setSendMsgBtnState(true)
    const data = {
      fromMe: true,
      _id: new Date().toUTCString() + "_message",
      name: "Celebrationjump",
      type: "text_message",
      readRecipt: false,
      category: "fromMe",
      phone:props.selectedMessage._id.phone,
      message:msg
    }
    const resp = await sendTextMessage(data)
    if(resp.data.success){
      props.selectedMessage.msg.push({//add the new message to the view
        body: msg,
        category: "fromMe",
        date: new Date(),
        name: "Celebrationjump",
        readRecipt: false,
        thread: null,
        type: "text_message",
        _id: new Date().toUTCString() + "_message"})
      setMsg("")
      setSendMsgBtnState(false)
    }
  }

  
  return (
    <div className='chat'>
      <div className="chat__header">
        <IconButton className='mr-2' onClick={()=>handleSidebar()}>
          <MenuIcon/>
        </IconButton>
        <Avatar/>
        <div className="chat__headerInfo">
          <h3>{props.selectedMessage ? props.selectedMessage.msg[0].name : "Select a Chat"}</h3>
        </div>
        <div className="chat__headerRight">
          <IconButton hidden>
            <SearchOutlined/>
          </IconButton>
          <IconButton hidden>
            <AttachFile/>
          </IconButton>
          <IconButton>
            <MoreVert/>
          </IconButton>
        </div>
      </div>
      <div className="chat__body">
        {props.selectedMessage && props.selectedMessage.msg.map((messageItem)=>{
          return <div key={messageItem._id} style={{maxWidth:"50%"}} className={messageItem.name == "Celebrationjump" ? "chat__message ml-auto" : "chat__message"} ref={messagesEndRef}>
            <h4 className='mb--2'>{messageItem.name}</h4>
            <br></br>
            {messageItem.image && <img alt="..." style={{width:'100px'}} src={ddns + '/userfiles/whatsapp/images/' + messageItem.image + '.jpg'} />}
            <span className='text-primary'>{messageItem.body}</span>
            <br></br>
            <span className="chat__timestamp text-info ">
              {new Date(messageItem.date).toUTCString()}
            </span>
          </div>
        })}
      </div>
      {props.selectedMessage &&
      <div className='mb-2'>
        <TextField placeholder="Write you text...."
          multiline
          style={{ width:'90%', marginLeft:8 }}
          maxRows={4}
          value={msg}
          
          onChange={(e)=>setMsg(e.target.value)} />
        <IconButton disabled={sendMsgBtnState} onClick={()=>handleSendMsg()}>
          <SendIcon/>
        </IconButton>
      </div>}
      
    </div>
  )
}

export default Chat